export default __webpack_public_path__ + "madfit-devices.00db283c.png";